import { CardsTest } from '../../../components/cardsTest/cardsTest';

export const SettingsIntegrationsCardsSalesforceTestView = (): JSX.Element => {
  return <CardsTest cardType="salesforce" />;
};
